import type { WargameSeverity } from "../../api/types";
import { k } from "../../i18n/i18n";

/** Gravités d'un contact du wargame : table unique pour le volet du wargame et le croquis des modes d'action
 *  (R2 : jetons `sev-*` d'index.css, le modéré au ton d'avertissement), utilisable en style en ligne et en SVG. */
export const SEVERITY_COLOR: Record<WargameSeverity, string> = {
  critique: "var(--color-sev-critical)",
  majeur: "var(--color-sev-major)",
  modere: "var(--color-sev-moderate)",
  mineur: "var(--color-sev-minor)",
};

/** Gravités de la plus forte à la plus faible (légende). */
export const SEVERITY_ORDER: WargameSeverity[] = ["critique", "majeur", "modere", "mineur"];

/** Libellés des gravités, en clés françaises traduites à l'affichage. */
export const SEVERITY_LABEL: Record<WargameSeverity, string> = {
  critique: k("Critique"),
  majeur: k("Majeur"),
  modere: k("Modéré"),
  mineur: k("Mineur"),
};
